import { toBN } from './number';

export const ZERO = toBN(0);
export const TWO = toBN(2);
export const MASK_251 = TWO.pow(toBN(251));